import { IComponentController } from "angular";
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IPaginationClass } from "../../../../../core/services/pagination.service";

interface IPagePb0016 extends IComponentController {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
}

/* @ngInject */
export default function Pb0016Controller(   Pagination: IPaginationClass) {
    const vm: IPagePb0016 = this;

    vm.multiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false
        },
        pagination: new Pagination({
            nombreElementPage: 50,
            nbElementsPossibles: [50, 100, 150]
        }),
        colonnesFixesGauche: [
            { nom: 'datcre', largeur: 250 },
            { nom: 'cobdsccen', largeur: 250 }
        ],
        colonnesVisibles: [
            { nom: 'usrcod', largeur: 120 },
            { nom: 'usrnom', largeur: 120 },
            { nom: 'cyhcom', largeur: 120 }
        ]
    };
}